import { supabase } from './supabaseClient';

export async function triggerMediaProcessing(mediaId: string, jobType?: string): Promise<void> {
  const { data: sessionData } = await supabase.auth.getSession();
  const accessToken = sessionData.session?.access_token;
  if (!accessToken) throw new Error('Sign in again before starting media processing.');

  const response = await fetch('/.netlify/functions/triggerBackground', {
    method: 'POST',
    headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({
      functionName: 'processMedia-background',
      payload: { mediaId, ...(jobType && { jobType }) },
    }),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({})) as { error?: string };
    throw new Error(body.error || `Processing request failed (${response.status})`);
  }
}
